<template>
    <div id="overview" class="pl-3 pr-3 pt-2">
        <div class="row w-100 m-0">
            <!-- start Column One -->
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6 pl-0 pr-0">
                        <div class="hide" v-bind:class='{show:!isLoading}'>
                            <overa :options='apStudGrowth.chartOptions' :series='apStudGrowth.series' :data="{lead:'Since June 2019',title:'Total Students',value:countTotalUser,icon:'fa fa-users'}"/>
                        </div>
                    </div>
                    <div class="col-md-6 pr-0">
                        <div class="hide" v-bind:class='{show:!isLoading}'>
                            <overa v-if="!isLoading" :options='apVisitGrowth.chartOptions' :series='apVisitGrowth.series' :data="{lead:'Since June 2019',title:'Total Visitors',value:countTotalVisitor,icon:'fa fa-eye'}"/>
                        </div>
                    </div>
                    <div class="col-md-12 p-0 mt-3">
                        <!-- start semesterInfo -->
                        <div class="hide p-3 rounded shadow-def-md bSecondary" v-bind:class='{show:!isLoading}'>
                            <p class="lead aPrimary">Semester info</p>
                            <div class="row">
                                <div class="col-md tSecondary">
                                    <p class="mb-0">Semester: <span class="tPrimary">Summer 2019</span></p>
                                    <p class="mb-0">Routine version: <span class="tPrimary">V-3</span></p>
                                    <p class="mb-0">Last Updated: <span class="tPrimary">23 May 2019</span></p>
                                    <hr class="divider">
                                    <p class="mb-0">Courses vsersion: <span class="tPrimary">V-1</span></p>
                                    <p class="mb-0">Teachers vsersion: <span class="tPrimary">V-1</span></p>
                                </div>
                                <div class="col-md">
                                    
                                </div>
                            </div>
                        </div>
                        <!-- end semesterInfo -->
                    </div>
                    <div class="col-md-12 p-0 mt-3">
                        <div class="hide" v-bind:class='{show:!isLoading}'>
                            <tableA v-if="recStudents.length!==0" :data='recStudents' :title='"Recent students"' :lead='"teal-4"'/>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end Column One -->
            <!-- start Column two -->
            <div class="col-md-6 p-0">
                <div class="row m-0 pl-3 mb-3">
                    <div class="hide col-md-3 pl-0 pr-1" v-bind:class='{show:!isLoading}'>
                        <div class="main-overv p-2 rounded bSecondary shadow-def-md">
                            <i class="fa fa-eye aPrimary"></i>
                            <p class="mb-0">
                                <span class="orng-5">{{sOverview.vToday}}</span>
                                <span class="tOptional"> | </span> 
                                <span class="blu-5">{{vOverview.vToday}}</span>
                            </p>
                            <h3 class="m-0 ml-2 tPrimary">{{tVisitedToday}}</h3>
                            <p class="m-0 tSecondary">Visited today</p>
                        </div>
                    </div>
                    <div class="hide col-md-3 pl-2 pr-1" v-bind:class='{show:!isLoading}'>
                        <div class="main-overv p-2 rounded bSecondary shadow-def-md">
                            <i class="fa fa-sign-in orng-6" aria-hidden="true"></i>
                            <p class="mb-0">
                                <span class="prpl-3">{{sOverview.sToday}}</span>
                                <span class="tOptional"> | </span> 
                                <span class="lim-7">{{vOverview.sToday}}</span>
                            </p>
                            <h3 class="m-0 ml-2 tPrimary">{{tSignedToday}}</h3>
                            <p class=" m-0 tSecondary">Signed today</p>
                        </div>
                    </div>
                    <div class="hide col-md-3 pl-2 pr-1" v-bind:class='{show:!isLoading}'>
                        <div class="main-overv p-2 rounded bSecondary shadow-def-md">
                            <i class="fa fa-eye aPrimary"></i>
                            <p class="indv mb-0">
                                <span class="cyn-7">{{sOverview.vWeek}}</span>
                                <span class="tOptional"> | </span> 
                                <span class="brwn-3">{{vOverview.vWeek}}</span>
                            </p>
                            <h3 class="m-0 ml-2 tPrimary">{{tVisitedWeek}}</h3>
                            <p class="m-0 tSecondary">Vis. in week</p>
                        </div>
                    </div>
                    <div class="hide col-md-3 pr-0 pl-2" v-bind:class='{show:!isLoading}'>
                        <div class="main-overv p-2 rounded bSecondary shadow-def-md">
                            <i class="fa fa-sign-in orng-6" aria-hidden="true"></i>
                            <p class="indv mb-0">
                                <span class="grn-5">{{sOverview.sWeek}}</span>
                                <span class="tOptional"> | </span> 
                                <span class="ingo-3">{{vOverview.sWeek}}</span>
                            </p>
                            <h3 class="m-0 ml-2 tPrimary">{{tSignedWeek}}</h3>
                            <p class="m-0 tSecondary">Sin. in week</p>
                        </div>
                    </div>
                </div>
                
                <!-- start barOverView col2box1 -->
                <div class="hide p-3 ml-3 rounded bSecondary shadow-def-md" v-bind:class="{show:!isLoading}">
                    <p class="lead mb-0 aPrimary">Overview of this month | year</p>
                    <apexchart type=bar height=300 :options="barOverview.options" :series="barOverview.series" />
                </div>
                <!-- end barOverView col2box1 -->
                <div class="hide ml-3 mt-3" v-bind:class='{show:!isLoading}'>
                    <tableA v-if="recVisitors.length!==0" :data='recVisitors' :title='"Recent visitors"' :lead='"orng-6"'/>
                </div>
            </div>
            <!-- end Column two -->
        </div>
    </div>
</template>

<script>
import dbRef from "../firebase/firebaseInit";
import { mapActions, mapGetters, mapMutations } from "vuex";
import XLSX from 'xlsx';

/** Componets */
import Over_a from "../components/overview/Overview_a"
import overLoader from "../components/layouts/OverLoader"
import tableA from "../components/tables/TableA"

export default {
  name: "Overview",
  data() {return {
        series: [70],
        chartOptions: {
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '30%',
                    }
                },
            },
        labels: ['Cricket']
        }
  }},
  components: {'overa':Over_a,overLoader,tableA},
    created(){
        this.$store.dispatch('reFreshDatas')
        //this.changeTheme(false);
    },
    methods:{
        ...mapMutations(['changeTheme'])
    },
    computed: {
        ...mapGetters([
            "isLoading",        "allStudents",
            "allVisitors",      "sOverview",
            "vOverview",        "countTotalUser",
            "countTotalVisitor","apStudGrowth",
            "apVisitGrowth",    "isDataLoaded",
            "tVisitedToday",    "tSignedToday",
            "tVisitedWeek",     "tSignedWeek",
            "barOverview",      "recStudents",
            "recVisitors",      "isDark"
        ])
    }
};
</script>

<style lang='scss' scoped>
#overview {
    .main-overv{
        position: relative;
        i{
            position: absolute;
            right: 1rem;top: 0.6rem;
            font-size: 3rem;
            opacity: 0.10;
        }
    }
    .hide{
        visibility: hidden;
        opacity: 0;
        transition: opacity 1s ease;
    }
    .show{
        visibility: visible;
        opacity: 1;
    }
}
</style>
